import BaseAPI from "../api";

const path: string = "/meeting-example-file";

export type listType = {
  keyword?: number;
  limit?: number;
  page?: number;
};

export class MeetingExampleFileApi extends BaseAPI {
  static list(query: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static patch(body: any, id:any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static findById(id:any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static delete(id:any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static uploadMeetingExampleFile(body:any): Promise<any> {
    return this.api.post(`upload-meeting-example-file`, body,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
  }
}
